import { useNavigate } from "react-router-dom";
import { Grid, Typography, TextField, Button, Box } from "@mui/material";
import DateFnsUtils from "@date-io/date-fns";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import { createTheme, ThemeProvider } from "@material-ui/core/styles";
import UseStyle from "../../../css/styles";
import { useState, useEffect } from "react";//FB 7469
import { Patient } from "../../../store";
import { SendForgotUsername } from "../../../api";
import { format } from "date-fns";
import useMediaQuery from "@mui/material/useMediaQuery";
import React from "react" //FB 7045 KK


// Update log
// FB  6192   02/06/2023  DK   Added page to handle Forgot username
// FB  7045   07/19/2023  KK  PP- Unable to enter Date fields manually
// FB  7239   08/17/2023  KK  PP- DOB when entered manually is not taken into account
// FB  7469   09/27/2023  SK   Patient Portal - Replace Doctor Direct with License Name , Update logo in Payment Receipt , Change in texts in Home Page
// FB  7528   10/05/2023  DK  Issue with DOB field (Picking a day earlier)

export default function ForgotUsername() {
  const matches = useMediaQuery("(min-width:600px)");
  const navigate = useNavigate();
  const JSAlert = require("js-alert");
  const styles = UseStyle();
  const theme = createTheme({
    palette: {
      primary: {
        main: "#18a2b8",
      },
    },
  });
  const handleDateChange = async (date: any) => {
    if (date != null && date != "Invalid Date") {
      //FB 7528
      handleInputChange(date); // FB 7239 KK
    }
  };
  var intialState: Patient = {} as Patient;
  intialState.PatientDOB = null as unknown as Date;
  const [fields, setFields] = useState(intialState);
  const [errors, setErrors] = useState<any>({});
  const handleInputChange = (e: any) => {
    if (!isNaN(Date.parse(e))) {
      setErrors({ PatientDOB: false });
      setFields({
        ...fields,
        PatientDOB: e,
      });
    } else {
      setErrors({ [e.target.name]: false });
      setFields({
        ...fields,
        [e.target.name]: e.target.value,
      });
    }
  };
  function Validate() {
    if (
      fields.PatientFirstName == undefined ||
      fields.PatientFirstName === ""
    ) {
      setErrors((errors: any) => ({ ...errors, PatientFirstName: true }));
      return false;
    }
    if (fields.PatientLastName == undefined || fields.PatientLastName === "") {
      setErrors((errors: any) => ({ ...errors, PatientLastName: true }));
      return false;
    }
    if (fields.PatientDOB == undefined || fields.PatientDOB.toString() == "") {
      setErrors((errors: any) => ({ ...errors, PatientDOB: true }));
      return false;
    }
    if (fields.PatientEmail == undefined || fields.PatientEmail === "") {
      setErrors((errors: any) => ({ ...errors, PatientEmail: true }));
      return false;
    }
    return true;
  }

  const handleSubmit = async (e: any) => {
    e.preventDefault();
    if (Validate()) {
      let response = await SendForgotUsername(fields);
      if (response != null) {
        if (response.alertType == "Success") {
          JSAlert.alert(response.message, null, JSAlert.Icons.Success).then(
            function () {
              navigate("/user/login");
            }
          );
        } else {
          JSAlert.alert(response.message, null, JSAlert.Icons.Failed).then(
            function () {
              window.location.reload();
            }
          );
        }
      }
    }
  };

  //FB 7469 - Begin
  const [HeaderText, setHeaderText] = useState("");

  async function LoadHeaderText() {
    let setting = sessionStorage.getItem("LicenseeName");
    if (setting != null) {
      setHeaderText(setting);
    }
  }

  useEffect(() => {
    LoadHeaderText();
  }, []);
  //FB 7469 - End

  return (
    <form onSubmit={handleSubmit}>
      {/* FB 7469 - Maintained structure for code after form tag and Doctor Direct Text Changed to License Name - Begin */}
      <Grid container spacing={1} flexDirection="column">
        <Grid
          item
          xs={12}
          style={{
            backgroundColor: "#F5F5F5",
            minHeight: "75px",
            alignItems: "center",
            display: "flex",
            paddingLeft: matches == false ? "20px" : "90px",
          }}
        >
          <Typography variant="h5" style={{ backgroundColor: "#F5F5F5" }}>
            <b>Recover your {HeaderText} Username</b>{/* FB 7469 */}
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography
            variant="h6"
            style={{
              marginLeft: matches == false ? "16px" : "80px",
              marginTop: "15px",
            }}
          >
            <b>Verification</b>
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography
            variant="body1"
            style={{
              marginLeft: matches == false ? "16px" : "80px",
              marginTop: "15px",
            }}
          >
            Please verify personal information to recover your username
          </Typography>
          <hr />
        </Grid>
        <Grid
          item
          xs={12}
          sm={6}
          md={6}
          lg={4}
          style={{
            marginLeft: matches == false ? "16px" : "80px",
            paddingRight: matches == false ? "16px" : "",
          }}
        >
          <TextField
            id="PatientFirstName"
            name="PatientFirstName"
            label="First name"
            value={fields.PatientFirstName}
            onChange={handleInputChange}
            error={errors.PatientFirstName}
            variant="outlined"
            required
            fullWidth
          />
        </Grid>

        <br></br>
        <Grid
          item
          xs={12}
          sm={6}
          md={6}
          lg={4}
          style={{
            marginLeft: matches == false ? "16px" : "80px",
            paddingRight: matches == false ? "16px" : "",
          }}
        >
          <TextField
            id="PatientLastName"
            name="PatientLastName"
            label="Last name"
            value={fields.PatientLastName}
            onChange={handleInputChange}
            error={errors.PatientLastName}
            variant="outlined"
            fullWidth
            required
          />
        </Grid>
        <br></br>
        <Grid
          item
          xs={12}
          sm={6}
          md={6}
          lg={4}
          style={{
            marginLeft: matches == false ? "16px" : "80px",
            paddingRight: matches == false ? "16px" : "",
          }}
        >
          {/* FB 7045 KK Begin */}
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <ThemeProvider theme={theme}>
              <KeyboardDatePicker
                InputLabelProps={{ shrink: true }}
                className={styles.datepickerroot}
                id="PatientDOB"
                name="PatientDOB"
                label="Date of Birth"
                value={fields.PatientDOB}
                format="MM/dd/yyyy"
                placeholder="MM/dd/yyyy"
                openTo="year"
                views={["year", "month", "date"]}
                onChange={(date) => handleDateChange(date)}
                inputVariant="standard"
                orientation="portrait"
                disableFuture
                required
                fullWidth
              />
            </ThemeProvider>
          </MuiPickersUtilsProvider>
          {/* FB 7045 KK End */}
        </Grid>
        <br></br>
        <Grid
          item
          xs={12}
          sm={6}
          md={6}
          lg={4}
          style={{
            marginLeft: matches == false ? "16px" : "80px",
            paddingRight: matches == false ? "16px" : "",
          }}
        >
          <TextField
            id="PatientEmail"
            name="PatientEmail"
            label="Email"
            value={fields.PatientEmail}
            onChange={handleInputChange}
            error={errors.PatientEmail}
            variant="outlined"
            fullWidth
            required
          />
        </Grid>
        <Grid item xs={6} sm={3} md={2}>
          {" "}
          <Button
            type="submit"
            variant="contained"
            className={styles.navigationButton}
            style={{
              marginLeft: matches == false ? "16px" : "80px",
              marginTop: "20px",
              marginBottom: "60px",
            }}
          //style={{ display: isTimeOut ? "flex" : "none", marginLeft: 5 }}
          //onClick={handleSubmit}
          >
            Submit
          </Button>
        </Grid>
      </Grid>
      {/* FB 7469 - End */}
    </form>
  );
}
